/**
 * ユーティリティ
 */

var utility = {

    /**
     * Copyright yearを設定する
     * @param  {Object} templateData
     */
    setCopyrightYear: function (templateData) {
        if (typeof sessionStorage.itunesCdd_copyRightYear !== 'undefined') {
            templateData.copyRightYear = sessionStorage.itunesCdd_copyRightYear;
        } else {
            var date = new Date();
            templateData.copyRightYear = date.getFullYear();
        }
        return templateData;
    },

    /**
     * TOP画面のリンクを設定する
     * @param  {Object} templateData
     */
    setTopLink: function (templateData) {
        var topLink = utility.getEnviromentInfo(onlineShopGiftCardList, environment_id);
        templateData.topLink = topLink;
        return templateData;
    },

    /**
     * 数値に金額用のカンマを付与する
     * @param  {integer} num
     */
    addComma: function (num) {
        var _num = String(num).replace(/^(-?\d+)(\d{3})/, '$1,$2');
        return (_num !== num) ? this.addComma(_num) : _num;
    },
    /**
     * 数値に付与されたカンマを取り除く。
     * @param  {string} str
     */
    removeComma: function (str) {
        return Number(str.split(',').join(''));
    },

    /**
     * 全角英数字を半角に変換する。
     */
    conversionHalfAngle: function (tagName) {
        var number = $(tagName).val();
        if (number) {
            number = number.replace(/[Ａ-Ｚ０-９ａ-ｚ]/g, function (s) {
                return String.fromCharCode(s.charCodeAt(0) - 65248);
            });
        }
        $(tagName).val(number);
    },

    /**
     * タイムセールを判断し、カウンドダウンの表示を行う。
     * 
     * @param  {json} data data.timesale_from_datetime及びdata.timesale_to_datetimeの階層が存在するjson。
     */
    timesale: function (data) {
        var startTime = new Date();
        var endTime = new Date(data.timesale_to_datetime);

        $('#ribbon').addClass("label-timesale");
        startTime.setSeconds(startTime.getSeconds() + 1);
        var diff = endTime - startTime;
        var times = 24 * 60 * 60 * 1000;
        var day = Math.floor(diff / times)
        var hour = Math.floor(diff % times / (60 * 60 * 1000))
        var min = Math.floor(diff % times / (60 * 1000)) % 60
        var sec = Math.floor(diff % times / 1000) % 60 % 60

        // 0サムレス
        var alerthour = ("0" + hour).slice(-2);
        var alertmin = ("0" + min).slice(-2);
        var alertsec = ("0" + sec).slice(-2);

        // 表示判定
        if (diff > 0) {
            if (day > 0) {
                $(".timesale-limit-data").text(
                    day + '日' + alerthour + '時間' + alertmin + '分' +
                    alertsec + '秒');
            } else {
                $(".timesale-limit-data").text(
                    alerthour + '時間' + alertmin + '分' + alertsec + '秒');
            }
            setTimeout(function () {
                utility.timesale(data);
            }, 1000);
        } else {
            // 終了した時のテキスト
            $(".timesale-limit-data").text('00時間00分00秒');
        }
    },

    /**
     * タイムセール時の期限内判定
     * @param {*} iTunesData 製品情報
     * @param {*} getProduct 
     * @param {*} timesaleflag タイムセールなら1、初回と通常は0
     */
    timesale_valid: function () {
        if (iTunesData.product.timesaleflag == 1) {
            var endTime = new Date(iTunesData.product.timesale_to_datetime);
            var now = new Date();
            if (now.getTime() > endTime.getTime()) {
                if (iTunesData.product.apple_card_show) {
                    window.location.replace(`error.html?errorCode=cpClosed2`);
                } else {
                    window.location.replace(`error.html?errorCode=cpClosed`);
                }
                return false;
            }
        }
        return true;
    },

    loadScript: function (src, callback) {
        var done = false;
        var head = document.getElementsByTagName('head')[0];
        var script = document.createElement('script');
        script.src = src;
        head.appendChild(script);
        // Attach handlers for all browsers
        script.onload = script.onreadystatechange = function () {
            if (!done && (!this.readyState ||
                    this.readyState === "loaded" || this.readyState === "complete")) {
                done = true;
                callback();
                // Handle memory leak in IE
                script.onload = script.onreadystatechange = null;
                if (head && script.parentNode) {
                    head.removeChild(script);
                }
            }
        };
    },

    getEnviromentInfo: function (objectInfo, environment_id) {
        var enviromentInfo = "";
        if (objectInfo[environment_id] != undefined) {
            enviromentInfo = objectInfo[environment_id];
        } else {
            enviromentInfo = objectInfo["default"];
        }
        return enviromentInfo;
    },

    /**
     * Topに移動させるボタンのコントロール
     */
    topBtnController: function () {
        var topBtn = $('#pagetop');
        topBtn.hide();

        $(window).scroll(function () {
            if ($(this).scrollTop() > 100) {
                topBtn.fadeIn();
            } else {
                topBtn.fadeOut();
            }
        });
        topBtn.click(function () {
            $('body,html').animate({
                scrollTop: 0
            }, 500);
            return false;
        });
    },

    formEventControl: function () {
        // クーポンチェックボックス制御
        $('#lbl-option-coupon').off('click').on('click', function () {
            $('#couponCodeErr').stop(true, false).slideToggle();
            $('#lbl-option-coupon').toggleClass("open");
            // ギフトチェックボックスの状態判定
            if (!$('#option-coupon').prop('checked')) {
                $('#couponCode').focus();
            } else {
                $('#couponCode').blur();
            }
        });

        // ギフトチェックボックス制御
        $('#lbl-option-gift').off('click').on('click', function () {
            $('#giftDetail').stop(true, false).slideToggle();
            $('#lbl-option-gift').toggleClass("open");
            // ギフトチェックボックスの状態判定
            if (!$('#option-gift').prop('checked')) {
                $('#sendFromAddress').focus();
            } else {
                $('#sendFromAddress').blur();
            }
        });

        // Variableボタン制御
        $('.variable-btn + label').off('click').on('click', function () {
            $('.item-list-wrap').find(".variable-form").stop(true, true).slideDown();
            $(this).addClass("open");
            $('#variablePrice').focus();
        });
        // Variableの金額入力テキスト表示制御
        $('.item-list li input + label').not('.variable-btn + label').click(function () {
            $('.item-list-wrap').find(".variable-form").stop(true, true).slideUp();
            $(this).removeClass("open");
        });
    },

    /**
     * サポート端末のチェック
     */
    deviceSupportCheck: function () {
        if (!UA.isSmartDevice) {
            window.location.replace(`error.html?errorCode=deviceNotSupport`);
            // 画面がすぐに遷移、そして阻止下へ運行
            throw new error();
        }
    },

    /**
     * UAチェック
     */
    userAgentChk: function userAgentChk() {
      var userAgent = window.navigator.userAgent.toLowerCase();
      // UAがIE10以前の場合エラーへ(iTunes不適用)
      if (userAgent.indexOf('msie') !== -1 && userAgent.indexOf('opera') === -1) {
        // お客さまのブラウザ・端末からはお手続きを行うことができません
        // セキュリティ強化のため、一部の古いスマートフォン、ブラウザからは、お手続きを行うことができません。
        window.location.replace("error.html?errorCode=message_error_ua");
        // 画面がすぐに遷移、そして阻止下へ運行
        throw new error();
      } else if (userAgent.indexOf('android') !== -1) {
        //Androidの場合、Androidのバージョンを取得
        var androidVer = parseFloat(userAgent.slice(userAgent.indexOf('android') + 8));
        if (androidVer < 5) {
          // お客さまのブラウザ・端末からはお手続きを行うことができません
          // セキュリティ強化のため、一部の古いスマートフォン、ブラウザからは、お手続きを行うことができません。
          window.location.replace("error.html?errorCode=message_error_ua");
          // 画面がすぐに遷移、そして阻止下へ運行
          throw new error();
        }
      }
    },

    /**
     * @description 現状のURLからGET Parameterを取得
     * @param {string} sParam GETパラメータのkey
     * @returns {string} GET ParameterのValue
     */
    getUrlParameter: function (sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    },

    /** 
     * セッション設定処理
     * @param {string} key sessionStorageに保存するkey
     * @param {string} value sessionStorageに保存するvalue
     */
    setSessionStorage: function (key, value) {
        if (!window.sessionStorage) return;
        try {
            sessionStorage.setItem(key, value);
        } catch (err) {
            return false;
        }
    },

    /**
     * tokenをSessionStore情報に格納する
     */
    setTokenToSessionStore: function () {
        var token = this.getUrlParameter("token");
        if (token) {
            this.setSessionStorage("token", token);
            // URLからtokenをクリア
            window.history.replaceState("", "", window.location.pathname);
        }
    },

    /**
     * tokenのリフレッシュ
     */
    tokeReflush: function (data) {
        var token = data.getResponseHeader('token');
        this.setSessionStorage("token", token);
    },
    /**
     * text が null or undefined の時に true を返す
     */
    isUndefinedOrNull: function (text) {
        return (text == undefined);
    }
}